/**
 * Utility functions for control classNames
 * Consistent styling across all control components
 */

import type { FormControl } from '@atlas-forms/types-js';

export interface ClassNameOptions {
  error?: boolean | string | null;
  hasError?: boolean | string | null;
  disabled?: boolean;
  isReadOnly?: boolean;
  touched?: boolean;
  baseClass?: string;
}

/**
 * Get base control container className
 */
export const getBaseControlClassName = (
  control: FormControl,
  options?: ClassNameOptions,
): string => {
  const classes = ['control'];

  if (control.width) {
    classes.push(`control--${control.width}`);
  }

  if (options?.error) {
    classes.push('control--error');
  }

  if (options?.disabled) {
    classes.push('control--disabled');
  }

  if (options?.touched) {
    classes.push('control--touched');
  }

  if (control.required) {
    classes.push('control--required');
  }

  return classes.join(' ');
};

/**
 * Get input element className
 */
export const getInputClassName = (options?: ClassNameOptions): string => {
  const classes = ['control__input'];

  if (options?.error) {
    classes.push('control__input--error');
  }

  if (options?.disabled) {
    classes.push('control__input--disabled');
  }

  return classes.join(' ');
};

/**
 * Get select element className
 */
export const getSelectClassName = (options?: ClassNameOptions): string => {
  const classes = ['control__select'];

  if (options?.error) {
    classes.push('control__select--error');
  }

  if (options?.disabled) {
    classes.push('control__select--disabled');
  }

  return classes.join(' ');
};
